import { Observable } from 'rxjs';
import { InjectionToken } from '../../injection';
import { ReadonlyBehaviorSubject } from '../../rxjs-utils';

import { OrganizationMembership } from '../data/organization-membership.do';
import { User } from '../data/user.do';

/**
 * Key used for storing the last selected membership ID.
 */
export const LAST_SELECTED_MEMBERSHIP_KEY = 'lastSelectedMembership';

/**
 * Legacy key for storing membership information.
 * TODO: #7144 Remove this BC layer.
 */
export const LEGACY_SELECTED_MEMBERSHIP_KEY = 'selectedMembership';

export interface IMobizStateService {
  /**
   * The currently logged in User.
   */
  currentUser: ReadonlyBehaviorSubject<User | null>;

  /**
   * The currently selected OrganizationMembership.
   */
  currentMembership: ReadonlyBehaviorSubject<OrganizationMembership | null>;

  /**
   * Flag for checking if the state has been initialized.
   */
  readonly initialized: boolean;

  /**
   * Change the currently selected OrganizationMembership.
   */
  changeCurrentMembership(currentMembership: OrganizationMembership): void;

  /**
   * Initialize the user and membership cache.
   */
  init(): Observable<void>;

  /**
   * Refresh the cached user and membership data.
   */
  refresh(): Observable<void>;

  /**
   * Refresh the cached user and membership data in the background.
   */
  refreshInBackground(): void;
}
export const IMobizStateService = new InjectionToken('IMobizStateService');
